<template>
  <div
    class="vue-js-switch-container"
    :class="{'reversed': reverse, 'has-label': !!label}"
  >
    <ToggleButton
      :width="48"
      :height="24"
      :value="value"
      :margin="4"
      :sync="true"
      :disabled="disabled"
      @change="change"
      @input="input"
    />

    <div
      v-if="label"
      class="vue-js-switch-label"
    >
      {{ label }}
    </div>
  </div>
</template>

<script>
import {ToggleButton} from 'vue-js-toggle-button/dist/ssr.index'

export default {
  components: {
    ToggleButton,
  },

  props: {
    /**
     * Initial state of the toggle button.
     */
    value: {
      type: Boolean,
      default: false,
    },

    /**
     * Name to attach to the generated input field
     */
    name: {
      type: String,
      default: undefined,
    },

    /**
     * Text to place in the label of the toggle button.
     */
    label: {
      type: [String, Number],
      default: undefined,
    },

    /**
     * Reverse the position of the label.
     */
    reverse: {
      type: Boolean,
      default: false,
    },

    /**
     * Button does not react on mouse events.
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    change (status) {
      /**
       * Triggered whenever state of the component changes.
       *
       * @event change
       * @property {object} status `value`: state of the object, `srcEvent`: source click event
       */
      this.$emit('change', status)
    },
    input (value) {
      /**
       * Input event for v-model
       *
       * @property {object} value state of the object
       */
      this.$emit('input', value)
    },
  },
}
</script>

<style lang="scss">


@mixin toggled-icon($color) {
  content: escape-svg(url("data:image/svg+xml,<svg height='16' viewBox='0 0 16 16' width='16' xmlns='http://www.w3.org/2000/svg'><path d='m7.4 0 1.4 1.4-5.4 5.4-3.4-3.4 1.4-1.4 2 2z' fill='#{$color}' transform='translate(3.5 4.6)'/></svg>"));
}

@mixin untoggled-icon($color) {
  content: escape-svg(url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16'><path fill='#{$color}' d='M4.4 10.16l1.44 1.43L8 9.44l2.16 2.15 1.43-1.43L9.44 8l2.15-2.16-1.43-1.43L8 6.56 5.84 4.41 4.41 5.84 6.56 8z'/></svg>"));
}

.vue-js-switch {
  &-container {
    display: inline-flex;
    align-items: center;
    background-color: transparent;

    &.has-label {
      min-width: 306px;
    }

    &.reversed {
      flex-direction: row-reverse;

      .vue-js-switch-label {
        margin-right: 1rem;
        margin-left: 0 !important;
      }
    }
  }

  &-label {
    font-size: 14px;
    margin-left: 1rem;
    line-height: 1.43;
    letter-spacing: normal;
    color: $gray-900;
  }
}

.vue-js-switch {
  margin-bottom: 0 !important;

  &:focus {
    outline: none;

    .v-switch-core {
      box-shadow: 0px 0px 0px 2px $cyan-500;
    }
  }

  &.disabled {
    &.toggled {
      .v-switch-button {
        &:after {
          @include toggled-icon('#E2E2E2');
        }
      }
    }

    .v-switch-button {
      &:after {
        @include untoggled-icon('#E2E2E2');
      }
    }
  }

  &.toggled {
    .v-switch-core {
      background: $cyan-700 !important;
    }

    .v-switch-button {
      &:after {
        @include toggled-icon('#00778f');
      }
    }
  }

  &.disabled {
    .v-switch-core,
    &.toggled.v-switch-core {
      background: $gray-200 !important;
    }
  }

  .v-switch-core {
    background: $gray-300 !important;
  }

  .v-switch-button {
    &:after {
      @include untoggled-icon('#b2b2b2');
      display: block;
      height: 16px;
      width: 16px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
}
</style>
